import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

type UpdateLockeNPVReq = {
  externalCode: string;
  yearsToRetire: number | null;
};

export function useUpdateYearsToRetire() {
  return useMutationWithValidation<boolean, UpdateLockeNPVReq>({
    mutationFn: async (data: UpdateLockeNPVReq) => {
      const url =
        
        `Salesforce/UpdateYearsToRetire/${data.externalCode}?yearsToRetire=${data.yearsToRetire}`;

      const response = await axiosInstance({
        method: "PUT",
        url,
      });

      return response.data as DataAwareResponse<boolean>;
    },
  });
}
